const data = {
	"width": 24,
	"height": 24,
	"body": "<g id=\"evaChevronRightFill0\"><g id=\"evaChevronRightFill1\"><path id=\"evaChevronRightFill2\" fill=\"currentColor\" d=\"M10.5 17a1 1 0 0 1-.71-.29a1 1 0 0 1 0-1.42L13.1 12L9.92 8.69a1 1 0 0 1 0-1.41a1 1 0 0 1 1.42 0l3.86 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-.7.32Z\"/></g></g>"
};
exports.__esModule = true;
exports.default = data;
